import { render, staticRenderFns } from "./fcPic.vue?vue&type=template&id=61c3261d"
import script from "./fcPic.vue?vue&type=script&lang=js"
export * from "./fcPic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports